var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatRacing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 18,
    fill: "#e7e2ff"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 14,
    y: 14,
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8899A6",
    d: "M5 36c-1.104 0-2-.896-2-2V3c0-1.104.896-2 2-2s2 .896 2 2v31c0 1.104-.896 2-2 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAB8C2",
    d: "M5 1c-1.105 0-2 .895-2 2v31c0 .276.224.5.5.5s.5-.224.5-.5V4.414C4 3.633 4.633 3 5.414 3H7c0-1.105-.895-2-2-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8899A6",
    d: "M5 36c-1.104 0-2-.896-2-2V3c0-1.104.896-2 2-2s2 .896 2 2v31c0 1.104-.896 2-2 2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAB8C2",
    d: "M5 1c-1.105 0-2 .895-2 2v31c0 .276.224.5.5.5s.5-.224.5-.5V4.414C4 3.633 4.633 3 5.414 3H7c0-1.105-.895-2-2-2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#31373D",
    d: "M32.396 3.082C30.732 2.363 28.959 2.006 27 1.974l-1.375.38L21 3l-1-.128c-.237.051-.476.099-.711.15-2.169.469-4.23.894-6.289.982L12 5 6 4v19h6l1 2h.077c2.244-.096 4.472-.556 6.633-1.022l.29-.061.646-.645 5.438-.708.916.41c1.68.032 3.193.335 4.604.944.309.133.665.103.945-.082.282-.186.451-.499.451-.836V4c0-.399-.237-.76-.604-.918z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E8ED",
    d: "M13 4.004c-.239.01-.478.035-.717.035-1.797 0-3.396-.313-4.887-.957-.308-.135-.665-.103-.945.083C6.169 3.349 6 3.664 6 4v6s3.292 1 7 1V4.004zM20 10s-3.75 1-7 1v7c3 0 7-1 7-1v-7zm7-1V1.974c-.096-.002-.186-.013-.283-.013-2.267 0-4.521.442-6.717.911V10s2.167-1 7-1zM6.604 23.918c1.5.648 3.09.993 4.82 1.082H13v-7c-4.167 0-7-1-7-1v6c0 .399.237.76.604.918zM20 17v6.916c2.313-.499 4.511-.955 6.717-.955.097 0 .187.011.283.013V16c-4.5 0-7 1-7 1zm7-1c2.676 0 4.82.56 6 .954V9.908C31.853 9.527 29.769 9 27 9v7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatRacing);
export default __webpack_public_path__ + "static/media/cat-racing.47590e3ee3ad4de65c1b2157328a1afa.svg";
export { ForwardRef as ReactComponent };